import { render, staticRenderFns } from "./VoluntaryPaymentsChart.vue?vue&type=template&id=b97c2490&scoped=true"
import script from "./VoluntaryPaymentsChart.vue?vue&type=script&lang=js"
export * from "./VoluntaryPaymentsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97c2490",
  null
  
)

export default component.exports